export enum TimeZoneFormatEnum {
    timeZoneFormat = 'MMMM DD, YYYY hh:mm A z',
    // Feb 08, 2022
    shortTimeZoneFormat = 'MMM DD, YYYY',
    // Feb 08, 2022 - 08:01 AM EST
    longTimeZoneFormat = 'MMM DD, YYYY - hh:mm A z',
    timeZoneOffsetFormat = 'MMMM DD, YYYY hh:mm A z (UTCZ)'
}
